import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("学習予定の追加")
const _hoisted_2 = {
  key: 0,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_3 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "leading-7 text-sm font-medium text-gray-500" }, " １回だけの学習予定 ", -1)
const _hoisted_5 = { class: "flex flex-wrap items-center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "削除", -1)
const _hoisted_7 = {
  key: 0,
  class: "mt-1 text-red-500 text-xs"
}
const _hoisted_8 = { class: "flex flex-col items-center" }
const _hoisted_9 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "4",
  class: "w-4 h-4 mr-2",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M12 6v6m0 0v6m0-6h6m-6 0H6" })
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "入力欄を追加する", -1)
const _hoisted_11 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "leading-7 text-sm font-medium text-gray-500" }, " 繰り返しの学習予定 ", -1)
const _hoisted_13 = { class: "flex-1" }
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = { class: "flex flex-col lg:flex-row lg:h-12" }
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = {
  key: 0,
  class: "mt-1 text-red-500 text-xs"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("span", null, "削除", -1)
const _hoisted_19 = { class: "flex flex-col items-center" }
const _hoisted_20 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "4",
  class: "w-4 h-4 mr-2",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M12 6v6m0 0v6m0-6h6m-6 0H6" })
], -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("span", null, "入力欄を追加する", -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 学習予定を登録 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ms_student_picker = _resolveComponent("ms-student-picker")
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_select_box = _resolveComponent("m-select-box")
  const _component_m_base_modal = _resolveComponent("m-base-modal")

  return (_openBlock(), _createBlock(_component_m_base_modal, { onClose: _ctx.close }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      (_ctx.usePicker)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode(_component_ms_student_picker, {
              defaultStudentIds: _ctx.defaultStudentIds,
              onUpdate: _ctx.onStudentsUpdated
            }, null, 8, ["defaultStudentIds", "onUpdate"])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reservations, (row, rowIndex) => {
          return (_openBlock(), _createBlock("div", {
            key: `reservation${rowIndex}`,
            class: "mx-auto mb-2 rounded-md border-2 border-gray-200 px-3 py-2"
          }, [
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_m_text_field, {
                name: `reservation${rowIndex}_date`,
                type: "date",
                class: "my-1 flex-1",
                value: row.data.date,
                onInput: ($event: any) => (row.data.date = $event)
              }, null, 8, ["name", "value", "onInput"]),
              _createVNode(_component_m_text_field, {
                name: "time",
                type: "time",
                placeholder: "18:00",
                class: "my-1 ml-2 flex-1",
                value: row.data.time,
                onInput: ($event: any) => (row.data.time = $event)
              }, null, 8, ["value", "onInput"]),
              _createVNode(_component_m_button, {
                class: "my-1 ml-4",
                color: "primary-500",
                "hover-color": "primary-600",
                onClick: ($event: any) => (_ctx.removeReservationRow(rowIndex))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_m_icon, { type: "trash" }),
                  _hoisted_6
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            (
              row.data.date &&
                row.data.time &&
                !_ctx.isFuture(row.data.date, row.data.time)
            )
              ? (_openBlock(), _createBlock("div", _hoisted_7, " 未来の日時を選択してください "))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", {
            class: "flex items-center text-sm rounded-md text-gray-400 font-medium px-4 py-2 border-2 border-gray-200 cursor-pointer transition-colors duration-300 hover:text-primary-500 hover:border-primary-500",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addReservationRow && _ctx.addReservationRow(...args)))
          }, [
            _hoisted_9,
            _hoisted_10
          ])
        ])
      ]),
      _createVNode("div", _hoisted_11, [
        _hoisted_12,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.regularlyReservations, (row, rowIndex) => {
          return (_openBlock(), _createBlock("div", {
            key: `regularReservation${rowIndex}`,
            class: "flex flex-wrap items-center justify-start mx-auto mb-2 rounded-md border-2 border-gray-200 px-3 py-2"
          }, [
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _createVNode(_component_m_select_box, {
                  key: `week${rowIndex}`,
                  name: `week${rowIndex}`,
                  options: _ctx.weekOptions,
                  value: row.data.weekday,
                  "value-key": "id",
                  "text-key": "text",
                  class: "my-1 flex-1",
                  onChange: ($event: any) => (row.data.weekday = $event)
                }, null, 8, ["name", "options", "value", "onChange"]),
                _createVNode(_component_m_text_field, {
                  name: "time",
                  type: "time",
                  class: "my-1 ml-2 flex-1",
                  value: row.data.time,
                  onInput: ($event: any) => (row.data.time = $event)
                }, null, 8, ["value", "onInput"])
              ]),
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, [
                  _withDirectives(_createVNode("input", {
                    id: `useDeletionTime${rowIndex}`,
                    "onUpdate:modelValue": ($event: any) => (row.data.useDeletionTime = $event),
                    type: "checkbox",
                    name: `useDeletionTime${rowIndex}`,
                    class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                  }, null, 8, ["id", "onUpdate:modelValue", "name"]), [
                    [_vModelCheckbox, row.data.useDeletionTime]
                  ]),
                  _createVNode("label", {
                    for: `useDeletionTime${rowIndex}`,
                    class: "pl-2 cursor-pointer text-gray-500 text-sm"
                  }, " 繰り返し終了日を設定する ", 8, ["for"])
                ]),
                (row.data.useDeletionTime)
                  ? (_openBlock(), _createBlock(_component_m_text_field, {
                      key: 0,
                      name: `deletionDay${rowIndex}`,
                      type: "date",
                      value: row.data.deletionTime,
                      class: "flex-1 ml-2 text-sm mt-2 lg:mt-0",
                      onInput: ($event: any) => (row.data.deletionTime = $event)
                    }, null, 8, ["name", "value", "onInput"]))
                  : _createCommentVNode("", true)
              ]),
              (
                row.data.deletionTime && !this.isFuture(row.data.deletionTime)
              )
                ? (_openBlock(), _createBlock("div", _hoisted_17, " 未来の日時を選択してください "))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_m_button, {
              class: "ml-4",
              color: "primary-500",
              "hover-color": "primary-600",
              onClick: ($event: any) => (_ctx.removeRegularlyReservationRow(rowIndex))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_m_icon, { type: "trash" }),
                _hoisted_18
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]))
        }), 128)),
        _createVNode("div", _hoisted_19, [
          _createVNode("div", {
            class: "flex items-center text-sm rounded-md text-gray-400 font-medium px-4 py-2 border-2 border-gray-200 cursor-pointer transition-colors duration-300 hover:text-primary-500 hover:border-primary-500",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addRegularlyReservationRow && _ctx.addRegularlyReservationRow(...args)))
          }, [
            _hoisted_20,
            _hoisted_21
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        disabled: !_ctx.isValidData,
        onClick: _ctx.reserve
      }, {
        default: _withCtx(() => [
          _hoisted_22
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]))
}